import { useOutletContext } from "react-router";

import { ShieldIcon, Table } from "@prequel/shared-components";

import { ExistingRecipient, ExistingSourceCredential } from "@/types";
import ExistingSource from "@/types/sources";

type SourceCredentialsTableProps = {
  sourceCredentials: ExistingSourceCredential[] | undefined;
  sources: ExistingSource[] | undefined;
  recipients: ExistingRecipient[] | undefined;
};
const SourceCredentialsTable = () => {
  const { sourceCredentials, sources, recipients } = useOutletContext<SourceCredentialsTableProps>();
  const rows = [...(sourceCredentials || [])].map((credential) => {
    const source = sources?.find(({ id }) => id === credential.source_id);
    const recipient = recipients?.find(({ id }) => id === credential.recipient_id);
    return {
      id: credential.id,
      cells: [
        {
          value: recipient ? recipient.name : "Not Found",
        },
        {
          value: source ? source.name : "Not Found",
        },
        { value: credential.username },
      ],
    };
  });

  const columns = ["Recipient Name", "Source Name", "Username"];

  if (rows.length === 0) {
    return (
      <div className="flex-col rounded-sm border border-gray-200 bg-gray-50 p-4 text-sm text-gray-500">
        <div className="flex">
          <ShieldIcon className="size-12 text-emerald-600" aria-hidden="true" />
          <div className="ml-3">
            <p className="mb-1 font-medium text-gray-900">
              {
                "Recipient source credentials is not enabled on your account, talk to support if you'd like to use this feature."
              }
            </p>
            <p>
              Recipient source credentials can be used when a data source uses role-based-access-control and a unique
              set of credentials must be used per source-recipient pair. Using recipient source credentials is only
              recommended if your source requires RBAC.{" "}
              <a
                target="_blank"
                href="https://docs.prequel.co/export/api-reference/overview"
                rel="noreferrer"
                className="
                  font-medium text-primary-600
                  hover:text-primary-500
                "
              >
                Learn more
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Table columns={columns} rows={rows} footer={rows ? `${rows.length} credentials` : ""} />
    </>
  );
};

export default SourceCredentialsTable;
